import { FilterSelector } from '../entities/candidate_experience/FilterSelector';
import { humanize } from './humanize';

export const getDefaultSelectedFilter = () => {
  return {
    value: FilterSelector.Jobs.valueOf(),
    label: humanize(FilterSelector.Jobs.valueOf()),
  };
};
